/**
 * Image Text Block Component
 * Handles expand/collapse interaction for image-text blocks with expand-up animation
 */
import { devLogger } from "@/utils/dev-logger.util";
/**
 * CollapseContent component
 * Adds click functionality to toggle content visibility for expand-up animation
 */
export const CollapseContent = (element) => {
    // Check if this block has the expand-up animation
    const isExpandUp = element.getAttribute("data-expanded");
    if (!isExpandUp) {
        return;
    }
    // Find expand icon
    const expandIcon = element.querySelector("[data-toggle]");
    if (!expandIcon) {
        devLogger.warn("CollapseContent: Required elements not found");
        return;
    }
    // State to track if content is expanded
    let isExpanded = false;
    /**
     * Toggle the expanded state
     */
    const toggleExpand = (event) => {
        event.preventDefault();
        event.stopPropagation();
        isExpanded = !isExpanded;
        if (isExpanded) {
            element.setAttribute("data-expanded", "true");
        }
        else {
            element.setAttribute("data-expanded", "false");
        }
    };
    // Add click event listener to the expand icon
    expandIcon.addEventListener("click", toggleExpand);
    // Make the icon keyboard accessible
    expandIcon.setAttribute("role", "button");
    expandIcon.setAttribute("tabindex", "0");
    // Add keyboard support (Enter and Space keys)
    expandIcon.addEventListener("keydown", (event) => {
        if (event.key === "Enter" || event.key === " ") {
            toggleExpand(event);
        }
    });
    // Set initial aria-expanded state
    element.setAttribute("data-expanded", "false");
    // Cleanup function (if component needs to be destroyed)
    return () => {
        expandIcon.removeEventListener("click", toggleExpand);
    };
};
